frappe.ui.form.ControlMarkdownEditor = frappe.ui.form.ControlCode.extend({
	editor_class: 'markdown',
	make_ace_editor() {
		this._super();

		this.ace_editor_target.wrap(`<div class="${this.editor_class}-container">`);
		this.markdown_container = this.$input_wrapper.find(`.${this.editor_class}-container`);
		
		this.markdown_container.css("display", "flex");
		this.ace_editor_target.css("flex", 1)

		this.editor.getSession().setUseWrapMode(true);

		this.mode = "code";
		this.mode_btn = $.parseHTML(`
			<div class="btn-group" role="group" style="margin-bottom: 5px">
				<button type="button" class="btn btn-primary btn-xs btn-code">
					<i class="fa fa-code" />
				</button>
				<button type="button" class="btn btn-default btn-xs btn-split">
					<i class="fa fa-columns" />
				</button>
				<button type="button" class="btn btn-default btn-xs btn-preview">
					<i class="fa fa-desktop" />
				</button>
			</div>
		`)

		$(this.mode_btn).find(".btn-code").click(() => this.set_mode("code"));
		$(this.mode_btn).find(".btn-split").click(() => this.set_mode("split"));
		$(this.mode_btn).find(".btn-preview").click(() => this.set_mode("preview"));

		this.markdown_container.parent().prepend(this.mode_btn);

		this.markdown_preview = $(`<div class="${this.editor_class}-preview border rounded" style="flex: 1; height: 300px; max-width: 800px">`).hide();
		this.markdown_container.append(this.markdown_preview);
		
		// Scroll events
		// this.editor.session.on('changeScrollTop',
		// 	(scroll) => {
		// 		if(this.mode == "code") return;
		// 		const editorHeight = this.editor.session.getScreenLength() * this.editor.renderer.lineHeight
		// 		this.markdown_preview.scrollTop((scroll/editorHeight) * this.markdown_preview[0].scrollHeight)
		// 	}
		// );

		if(this.after_render) this.after_render();
	},

	set_mode(mode){
		this.mode = mode;
		$(this.mode_btn).find(".btn").removeClass("btn-primary").addClass("btn-default");
		$(this.mode_btn).find(".btn-" + mode).addClass("btn-primary").removeClass("btn-default");
		
		this.markdown_preview.hide();
		this.ace_editor_target.hide();

		if(mode == "code") this.ace_editor_target.show()
		else if(mode == "split"){
			this.ace_editor_target.show();
			this.markdown_preview.show();
		}
		else if(mode == "preview") this.markdown_preview.show()

		this.editor.resize(true);
	},

	set_language() {
		this.df.options = 'Markdown';
		this._super();
	},

	update_preview() {
		const value = this.get_value() || "";
		const last_scroll = this.markdown_preview.scrollTop();
		this.markdown_preview.html(frappe.markdown(value));
		setTimeout(() => {
			this.markdown_preview.scrollTop(last_scroll)
		}, 100);
	},

	set_formatted_input(value) {
		this._super(value)
			.then(() => {
				this.update_preview();
			});
	},

	set_disp_area(value) {
		this.disp_area && value && $(this.disp_area).html(frappe.markdown(value));
	},

	make_wrapper: function() {
		this._super();
		this.$wrapper.find(".like-disabled-input").addClass("for-markdown");
	},

	refresh_height() {
		this._super();
		this.markdown_preview.css('height', this.expanded ? 600 : 300);
	},
});
